import initTranslationsICU, { i18n } from "@babackapp/translations/init-icu";
import { datadogRum } from "@datadog/browser-rum";
import { setI18n } from "react-i18next";

const reportedMissingKeys = new Set<string>();

initTranslationsICU(undefined, ["frontend", "return-widget-v3"], (key, lngs) => {
  if (reportedMissingKeys.has(key)) return;
  reportedMissingKeys.add(key);
  if (datadogRum.getInitConfiguration()) {
    datadogRum.addError(new Error(`[i18n] Missing translation key: "${key}"`), {
      key,
      languages: lngs,
    });
  }
});

// i18n comes from packages/translations/init-icu which resolves i18next from root
// node_modules (no local copy there) — same singleton that initTranslationsICU initializes.
// setI18n from app's react-i18next (root copy) so useTranslation's getI18n() finds it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
setI18n(i18n as any);

export default i18n;
